export const selectedMacAddress = state => state.selectedMacAddress;
